import { Field } from 'formik';
import { Checkbox } from '../components';
import CurrencyInput from './common/CurrencyInput';
import { useProductContext } from '../contexts/ProductContext';
import { formatDate } from '@demandproai/shared';
import XButton from './common/XButton';
import { settlementFormColClasses, doneColClasses } from './common/settlementClasses';

const checkboxGroupClasses =
    'flex items-center gap-2.5 ' +
    '[&_input[type=checkbox]]:w-4.5! [&_input[type=checkbox]]:h-4.5! [&_input[type=checkbox]]:cursor-pointer ' +
    '[&_label]:cursor-pointer [&_label]:text-base [&_label]:text-label';

// Used on the lone "Case Settled and Closed" wrapper so its checkbox matches
// the size of the policy-limit checkboxes above (which sit inside checkboxGroupClasses).
const settledCheckboxSizeClasses =
    '[&_input[type=checkbox]]:w-4.5! [&_input[type=checkbox]]:h-4.5!';

const cardRowClasses = "grid grid-cols-2 gap-x-6";

const cardColClasses = "flex flex-col";


const SettlementForm = ({ 
    clientId,
    client,
    caseData,
    isSettleAllView,
    isAlreadySettled,
    user,
    onSave,
    formik
}) => {
    const { isPFASType } = useProductContext();

    const isAutoAccidentOrPFAS = (isPFASType && isPFASType(caseData?.caseInfo?.caseType)) || caseData?.caseInfo?.caseType === "AUTO_ACCIDENT";

    return (
        <div className={cardRowClasses}>
            {/* Third Party Settlement */}
            <div className={cardColClasses}>
                <div>
                    <CurrencyInput
                        label="Third Party Settlement Amount"
                        name={`${clientId}.thirdPartySettlementAmount`}
                        {...formik?.getFieldProps(`${clientId}.thirdPartySettlementAmount`)}
                    />
                </div>
                <div className={checkboxGroupClasses}>
                    <Field
                        name={`${clientId}.isThirdPartyPolicyLimitSettled`}
                        label="Case Settled for Third Party Policy Limit"
                        component={Checkbox}
                    />
                </div>
            </div>

            {/* UIM/UM Settlement - Only for Auto Accident */}
            {isAutoAccidentOrPFAS && (
                <div className={cardColClasses}>
                    <div>
                        <CurrencyInput
                            label="UIM/UM Settlement Amount"
                            name={`${clientId}.uimUmSettlementAmount`}
                            {...formik?.getFieldProps(`${clientId}.uimUmSettlementAmount`)}
                        />
                    </div>
                    <div className={checkboxGroupClasses}>
                        <Field
                            name={`${clientId}.isUimUmPolicyLimitSettled`}
                            label="Case Settled for UIM/UM Policy Limit"
                            component={Checkbox}
                        />
                    </div>
                </div>
            )}

            {/* Case Settled Checkbox */}
            <div className={settledCheckboxSizeClasses}>
                <Field
                    name={`${clientId}.isCaseSettled`}
                    placeholder=""
                    disabled={isAlreadySettled}
                    label={`Case Settled and Closed ${
                        isAlreadySettled
                            ? `on ${formatDate(client?.settlement?.settledAt)}`
                            : ''
                    }`}
                    component={Checkbox}
                />
                
                {user?.isDelayedPayment && (
                    <p className="text-danger mt-2 mb-0!">
                        Note: Marking this case settled will charge the lien.
                    </p>
                )}
            </div>

            {/* Done Button - Only for individual view */}
            {!isSettleAllView && (
                <div className={`${settlementFormColClasses} ${doneColClasses}`}>
                    <XButton type="submit" onClick={onSave}>
                        Done
                    </XButton>
                </div>
            )}
        </div>
    );
};

export default SettlementForm;